void main(){
    float strength = distance(gl_PointCoord, vec2(0.5));
        strength= 1.0 - strength;
        strength= pow(strength, 6.0);
        gl_FragColor = vec4(0.9608, 0.9216, 0.7490, strength);
        #include <colorspace_fragment>
}